module.exports = __webpack_public_path__ + "img/540a.90df1899.png";